import { render } from "./ConsultView.vue?vue&type=template&id=b4d4b5a4&scoped=true"
import script from "./ConsultView.vue?vue&type=script&lang=js"
export * from "./ConsultView.vue?vue&type=script&lang=js"

import "./ConsultView.vue?vue&type=style&index=0&id=b4d4b5a4&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d4b5a4"]])

export default __exports__